module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "invoice"
  }, [_c('dt', {
    staticClass: "title"
  }, [_vm._v("发票信息")]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("抬头类型：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.titleType || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("发票抬头：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.title || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("纳税识别号：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.taxpayerNo || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("注册电话：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.registeredPhone || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("开票地址：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.invoiceAddress || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.bank || '空'))])]), _vm._v(" "), _c('dd', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "name"
  }, [_vm._v("开户账号：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.account || '空'))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-240e7775","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/invoice/customer-invoice.vue
// module id = 1237
// module chunks = 82